import { render } from "./Sidebar.vue?vue&type=template&id=544c6f33&scoped=true&lang=true"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"

import "./Sidebar.vue?vue&type=style&index=0&id=544c6f33&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-544c6f33"

export default script